const CookieIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="47"
      viewBox="0 0 46 47"
      fill="none"
    >
      <circle cx="23" cy="23.5" r="23" fill="white" />
      <path
        d="M21.2431 21.1724C22.2135 21.1724 23.0001 20.3857 23.0001 19.4154C23.0001 18.4451 22.2135 17.6585 21.2431 17.6585C20.2728 17.6585 19.4862 18.4451 19.4862 19.4154C19.4862 20.3857 20.2728 21.1724 21.2431 21.1724Z"
        fill="#4C5974"
      />
      <path
        d="M18.9005 27.0288C19.8709 27.0288 20.6575 26.2422 20.6575 25.2719C20.6575 24.3016 19.8709 23.515 18.9005 23.515C17.9302 23.515 17.1436 24.3016 17.1436 25.2719C17.1436 26.2422 17.9302 27.0288 18.9005 27.0288Z"
        fill="#4C5974"
      />
      <path
        d="M26.514 28.2001C27.1608 28.2001 27.6853 27.6757 27.6853 27.0288C27.6853 26.382 27.1608 25.8575 26.514 25.8575C25.8671 25.8575 25.3427 26.382 25.3427 27.0288C25.3427 27.6757 25.8671 28.2001 26.514 28.2001Z"
        fill="#4C5974"
      />
      <path
        d="M34.6545 22.3319C32.5578 22.2968 30.3207 20.0479 31.5154 17.3891C28.0366 18.5604 24.7453 15.5267 25.4364 12.048C17.2724 10.3262 11.2871 16.9674 11.2871 23.515C11.2871 29.9805 16.5345 35.2279 23.0001 35.2279C29.899 35.2279 35.3455 29.2777 34.6545 22.3319ZM23.0001 32.8853C17.8347 32.8853 13.6297 28.6804 13.6297 23.515C13.6297 19.638 16.8273 13.9337 23.0938 14.1212C23.5857 17.0962 25.9517 19.4623 28.9385 19.9074C29.0205 20.329 29.5476 22.8942 32.3587 24.1592C32.0191 29.2075 27.7555 32.8853 23.0001 32.8853Z"
        fill="#4C5974"
      />
    </svg>
  );
};

export default CookieIcon;
